// Mock data for Shilpa Agrawal's Portfolio

export const profileData = {
  name: "Shilpa Narendra Agrawal",
  shortName: "Shilpa Agrawal",
  title: "PMI Certified Project Management Professional",
  tagline: "Transforming complex challenges into strategic, data-driven solutions using agile methodologies",
  email: "agrawalshilpa857@gmail.com",
  phone: "+1 (402) 805-1247",
  location: "San Jose, California",
  linkedIn: "https://linkedin.com/in/agrawalshilpa",
  resumePath: "/assets/Shilpa_Agrawal_Resume.pdf",
  profileImage: "/assets/profile.jpg",
  aboutImage: "/assets/Shilpa_and_Sammy.avif",
  heroBackground: "/assets/hero.jpeg"
  //heroBackground: "/assets/hero copy.jpeg"
  //heroBackground: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1920&h=1080&fit=crop"
};

export const aboutData = {
  paragraphs: [
    "I believe project management isn’t just a career path—it’s a mindset that shows up in everyday decisions, whether you're launching a product, managing a team, or streamlining family logistics. Over the years, I’ve realized that my natural inclination to plan, organize, and optimize has always aligned with core project management principles like stakeholder engagement, risk mitigation, and scope management.",
    "Whether I led digital transformation initiatives at ALEWA, analyzed trends at Mathnasium, or managed multiple projects at Vault JS, I consistently applied structured project management frameworks to deliver clear, measurable results. With my PMP certification and experience across banking, tech, and education, I’m confident in my ability to adapt these frameworks to diverse professional environments and drive outcomes with purpose and precision."
  ]
};

export const certifications = [
  {
    id: 1,
    title: "Project Management Professional (PMP)",
    issuer: "Project Management Institute (PMI)",
    date: "March 2025",
    image: "/assets/PMI PMP Logo.avif",
    bullets: [
      "Mastered end-to-end project management lifecycle",
      "Learned to manage scope, time, cost, and quality",
      "Gained skills in risk assessment and mitigation",
      "Proficiency in predictive, agile, and hybrid approaches",
      "Prepared for real-world leadership in complex projects"
    ]
  },
  {
    id: 2,
    title: "Google Project Management",
    issuer: "Coursera",
    date: "February 2025",
    image: "/assets/Google Project Managament.avif",
    bullets: [
      "Effectively initiating projects for success",
      "Putting a plan together to achieve the goals set out for the project",
      "Managing and executing out a plan once set",
      "What Agile is and how project management fits in",
      "Real world applications of principles taught in the course"
    ]
  },
  {
    id: 3,
    title: "Certificate in Business Analytics",
    issuer: "San Jose State University",
    date: "December 2024",
    image: "/assets/Business Analytics.avif",
    bullets: [
      "Explored data mining, forecasting, and visualization",
      "Built dashboards using Tableau and Power BI",
      "Analyzed trends to support strategic decisions",
      "Applied statistical models to real-world datasets",
      "Gained hands-on experience with R and Excel tools"
    ]
  },
  {
    id: 4,
    title: "Program Management Foundations",
    issuer: "LinkedIn Learning",
    date: "December 2024",
    image: "/assets/Program Management.avif",
    bullets: [
      "Aligning program goals with organizational strategy",
      "Managing multiple related projects under a unified program",
      "Strategic alignment and portfolio management",
      "Resource optimization across programs"
    ]
  },
  {
    id: 5,
    title: "Six Sigma",
    issuer: "Advanced Innovation Group Pro Excellence (AIGPE)",
    date: "March 2025",
    image: "/assets/Six Sigma.avif",
    bullets: [
      "Eliminated inefficiencies using DMAIC",
      "Applied data-driven decisions and root cause analysis",
      "Learned quality control and improvement methods",
      "Used stats tools to optimize performance",
      "Reduced variation to boost customer satisfaction"
    ]
  }
];

export const skills = {
  programming: {
    title: "Programming & Data Analysis",
    items: ["Tableau", "Power BI", "R", "SQL", "Excel VBA", "Python"]
  },
  projectManagement: {
    title: "Project Management & Collaboration Tools",
    items: ["Jira", "Asana", "Microsoft Project", "Trello", "Confluence", "Slack"]
  },
  crm: {
    title: "CRM & Business Intelligence",
    items: ["HubSpot", "Salesforce", "Oracle", "SAP", "Zoho CRM"]
  },
  other: {
    title: "Other Technical Skills",
    items: ["Agile/Scrum", "Waterfall", "SDLC", "API Integration", "Data Modeling", "Process Mapping"]
  }
};

export const workExperience = [
  {
    id: 1,
    role: "Business Administrator",
    company: "Vault JS",
    location: "Los Altos, USA",
    dates: "June 2025 – Present",
    logo: "/assets/Vault JS Logo.png",
    description: "Lead revenue-driven marketing and operational initiatives that support enterprise growth and scalability. Designed and executed a trivia campaign and live event for privacy professionals, creating all marketing assets and an interactive quiz that converted attendees into long-term enterprise clients. Implemented Vault JS’s first 401(k) program to ensure compliance with state mandates and strengthen employee retention. Analyze vendor proposals and negotiate contracts to secure cost-efficient solutions aligned with strategic growth objectives. Organized and managed the company’s Zoom webinar series end-to-end, driving 90+ qualified attendees per session and generating high-value pipeline opportunities."
  },
  {
    id: 2,
    role: "IT Support Student Assistant",
    company: "San Jose State University",
    location: "San Jose, USA",
    dates: "Aug 2023 – May 2025",
    logo: "/assets/SJSU Logo.avif",
    description: "As part of the Interdisciplinary Science Building (ISB) project, I led classroom technology deployment, including faculty onboarding, mentoring student assistants, and completing the final admin handoff to the support team. I provided IT support to faculty and students, managed technical resources, and partnered with cross-functional teams to improve service delivery through data-driven process improvements. I also streamlined Windows and macOS software deployments, reducing rollout time by 40% while minimizing classroom disruptions."
  },
  {
    id: 3,
    role: "Program Coordinator",
    company: "Mathnasium",
    location: "San Jose, USA",
    dates: "Jun 2024 – Aug 2024",
    logo: "/assets/Mathnasium Logo.avif",
    description: "As Program Coordinator at Mathnasium, I built relationships with schools and local communities that increased student enrollment by 25%. Alongside managing over 100 client inquiries each week, I led parent communication initiatives and tracked student progress through performance analytics to support better outcomes. By analyzing enrollment trends, I improved marketing and outreach effectiveness by 15%."
  },
  {
    id: 4,
    role: "Project Manager",
    company: "ALEWA",
    location: "Kathmandu, Nepal",
    dates: "Jan 2020 – May 2023",
    logo: "/assets/Alewa.avif",
    description: "As Project Manager at ALEWA, I led ALEWA Traders’ e-commerce integration with Daraz, overseeing store setup, product listings, logistics, and regulatory compliance. I also developed a comprehensive e-commerce roadmap, optimized inventory management systems to prevent stockouts, and introduced KPI dashboards to drive data-informed decisions."
  },
  {
    id: 5,
    role: "Business Analyst",
    company: "ICICI Bank",
    location: "Nasik, India",
    dates: "Aug 2017 – Dec 2019",
    logo: "/assets/ICICI Bank Logo.avif",
    description: "Analyzed business processes and customer data to identify opportunities for operational improvement. Developed comprehensive reports and dashboards for senior management, driving strategic decision-making. Collaborated with IT teams to implement CRM enhancements that improved customer retention by 18%."
  }
];

export const professionalProjects = [
  {
    id: 1,
    name: "Alewa Life",
    subtitle: "Transforming a Traditional Business into a Digital Brand",
    image: "/assets/Alewa Life.avif",
    description: "Spearheaded the development and launch of Alewa Life, a custom e-commerce platform featuring 500+ SKUs across multiple product categories. Led the full project lifecycle from concept to deployment, delivering the MVP in 10 weeks by coordinating internal stakeholders, developers, designers, and an outsourced team. Launched ahead of the Holi sales season, achieving 150% of first-year revenue targets."
  },
  {
    id: 2,
    name: "Alewa – Daraz Integration",
    subtitle: "Driving Digital Innovation through Marketplace Integration",
    image: "/assets/alewa_daraz_integration.avif",
    description: "Led the integration of Alewa’s inventory and order management systems with Daraz, overseeing end-to-end marketplace setup, listing optimization, promotions coordination, and operational readiness. Implemented automated synchronization to reduce manual data entry by 90% and enable real-time inventory updates, increasing order fulfillment efficiency by 45%. Supported sustainable operations through team training and process documentation."
  }
];

export const academicProjects = [
  {
    id: 1,
    name: "Global Suicide Rate Analysis",
    tool: "R",
    subtitle: "Statistical Analysis & Data Visualization",
    image: "/assets/Global Suicide Rate Analysis.avif",
    description: "Analyzed 27K+ records across 1985–2016 to identify socio-economic and demographic drivers of global suicide rates. Used R to apply regression models, trees, boosting, and SVM, uncovering key patterns across age, gender, GDP, HDI, and regional trends. Findings showed higher suicide rates among males and older adults, with HDI revealing a surprising positive correlation. Results were visualized to support actionable public health policy recommendations."
  },
  {
    id: 2,
    name: "Analyzing Sales Trends",
    tool: "Tableau",
    subtitle: "Business Intelligence Dashboard",
    image: "/assets/Analyzing Sales Trend.avif",
    description: "Built interactive dashboards using Maven Analytics data to uncover sales, customer, and product trends for a global electronics retailer. Visualized KPIs like sales by year, region, gender, and subcategory using dynamic filters and parameter controls. Revealed key insights, including COVID-19’s sales impact and seasonal dips during tax season. Demonstrated strong data storytelling and user-focused dashboard design."
  },
  {
    id: 3,
    name: "Forecasting COVID-19 Trends",
    tool: "R",
    subtitle: "Time Series Analysis & Prediction",
    image: "/assets/Forecasting COVID-19 Trends.avif",
    description: "Conducted cross-country time series analysis of COVID-19 trends in the U.S. and Australia using R. Applied decomposition, exponential smoothing, ARIMA, Holt’s method, and harmonic regression to forecast cases and ICU admissions. Disproved seasonal assumptions through data validation and improved short-term prediction accuracy using fpp3, tsibble, and fable. Findings supported healthcare resource planning and policy decision-making."
  },
  {
    id: 4,
    name: "Operational Analytics for UK E-Commerce",
    tool: "Excel Solver",
    subtitle: "Optimization & Supply Chain Analysis",
    image: "/assets/Operational Analytics for UK-E-Commerce.avif",
    description: "Led operational analytics for a UK-based wholesale e-commerce dataset, focusing on pricing, logistics, inventory planning, and demand forecasting. Built linear programming and regression models using Excel Solver to identify a 33.65% breakeven discount threshold and optimize warehouse placement, reducing projected shipping costs by $25K while maintaining service levels. Regression results (R² = 0.94) highlighted quantity and price as primary sales drivers, with Mean and Moving Average models delivering accurate sales forecasts."
  },
  {
    id: 5,
    name: "Portfolio Risk & Return Analysis",
    tool: "Beta Coefficients",
    subtitle: "Financial Modeling & Risk Assessment",
    image: "/assets/Portfolio Risk & Return Analysis.avif",
    description: "Assessed risk-return profiles of California REIT and Brown Group against the Vanguard Index 500 by calculating returns, standard deviation, beta, and correlations. Built diversified portfolios to evaluate total and systematic risk, optimizing risk-adjusted returns for different investor profiles. Findings showed California REIT offered lower beta and stronger diversification potential, leading to a recommendation for risk-averse investors."
  },
  {
    id: 6,
    name: "Littlefield Technologies Operations Simulation",
    tool: "Simulation",
    subtitle: "Operations Management & Capacity Planning",
    image: "/assets/Littlefield Technologies Operations Simulation.avif",
    description: "Managed factory operations in the real-time simulation to maximize cash flow over a 268-day lifecycle. Optimized capacity, inventory, order scheduling, and contract pricing using demand forecasting and queue analysis. Resolved bottlenecks through phased machine investments and dynamic priority rules to improve throughput and profitability. Achieved runner-up performance, demonstrating strong operations strategy and data-driven decision-making."
  }
];

export const education = [
  {
    id: 1,
    degree: "Master of Business Administration (MBA)",
    field: "Specialization: Business Analytics",
    university: "San Jose State University",
    graduationDate: "May 2025",
    location: "San Jose, California",
    gpa: "4.0/4.0",
    coursework: [
      "Strategic Management",
      "Business Analytics",
      "Operations and Supply Chain Management",
      "Managerial Decision Analysis",
      "Forecasting for Business Analytics",
      "Financial Management",
      "Marketing Strategy",
    ]
  },
  {
    id: 2,
    degree: "Post Graduate Diploma in Banking",
    field: "Banking & Financial Services",
    university: "Manipal University",
    graduationDate: "July 2017",
    location: "Karnataka, India",
    gpa: "8.9/10",
    coursework: [
      "Financial Markets and Instruments",
      "Credit Analysis and Risk Management",
      "Banking Regulations and Compliance",
      "Retail and Corporate Banking Operations",
      "Risk Analysis",
      "CRM in Banking"
    ]
  },
  {
    id: 3,
    degree: "Bachelor of Engineering",
    field: "Computer Science",
    university: "Dr. Babasaheb Ambedkar Marathwada University",
    graduationDate: "June 2014",
    location: "Aurangabad, India",
    gpa: "3.4/4.0",
    coursework: [
      "Data Structures & Algorithms",
      "Database Management Systems",
      "Software Engineering",
      "Computer Networks",
      "Operating Systems",
      "Java and C++ Programming"
    ]
  }
];

export const footerData = {
  about: {
    name: "Shilpa Agrawal",
    title: "MBA | PMP | Business Analyst"
  },
  quickLinks: [
    { label: "Resume", href: "/assets/Shilpa_Agrawal_Resume.pdf" },
    { label: "Projects", href: "/projects" },
    { label: "Skills", href: "/#skills" }
  ],
  connect: {
    email: "agrawalshilpa857@gmail.com",
    phone: "+1 (402) 805-1247",
    linkedIn: "https://linkedin.com/in/agrawalshilpa",
    location: "San Jose, California"
  },
  certifications: [
    "PMP Certified",
    "Google PM",
    "Six Sigma",
    "Business Analytics"
  ]
};
